import { Component } from 'vue';

enum Routes {
	IMPORT_FILE = 'import-file',
	OVERVIEW = 'overview',
	ERROR_DETAILS = 'error-details'
}

interface IRouter {
	current: Routes;
	props: {
		id: string;
	};
}

type TRoutes = {
	[key in Routes]: Component;
};

export { IRouter, TRoutes, Routes };
